import React, { useEffect, useState } from "react";
import { AuthPost } from "../../services/http-client";
// import { SET_PLAYER_COACH_COUNTS } from "../../redux/slices/dashboard-overview-slice";
import { useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import OpenlinkIcon from "../../assets/images/openlink_icon.svg";
import GrapharrowIcon from "../../assets/images/grapharrow_icon.svg";
import DashboardChart from "../../components/chart/DashboardChart";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import CloseIcon from "../../assets/images/close_icon.svg";
import { adminDashboard, brandChart, brandDashboardCount, DashboardChartDetails, projectReport } from "../../services/super-admin.service";
import { selectCurrentUser } from "../../store/user/user.selector";
import SelectdateIcon from "../../assets/images/selectdate_icon.svg";
import PieChart from "../../components/chart/PieChart"
import RadialBarChart from "../../components/chart/RadialBarChart"
import { string } from "yup";
import styles from "./Dashboard.module.css"
import { BarChart } from "@mui/icons-material";
import { formatNumber } from "../../utils/helpers/helper";


const Dashboard = () => {
  const navigate = useNavigate();
  const [options, setOptions] = useState([]);
  const [chartSeries, setChartSeries] = useState([]);
  const [isChart, setIsChart] = useState(false);
  const [count, setCount] = useState({
    brands: 0,
    offers: 0,
    users: 0,
    transactions: 0,
  });

  const [ProjectSummary, setProjectSummary] = useState([]); //Projectsummary
  const [ProjectReportByName, setPrjectReportByName] = useState([]); // Report by receiver
  const [ProjectReportByPayer, setPrjectReportByPayer] = useState([]); // Report by who paid 
  const [ProjectReportByLocation, setPrjectReportByLocation] = useState([]);
  const [ProjectOverallReport, setPrjectOverallReport] = useState([]);
  const [teamPaymentReport, setteamPaymentReport] = useState([]); // overallpaidReport
  const user = useSelector(selectCurrentUser);

  const userType = user?.userDetail?.userType

  const [range, setRange] = useState({
    startDate: null,
    endDate: new Date(),
  });

  const [isOpen, setIsOpen] = useState(false);
  const handleTogglePicker = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (ranges) => {
    console.log(ranges["range1"]);
    const temp = {
      startDate: ranges["range1"]["startDate"],
      endDate: ranges["range1"]["endDate"],
    };
    setRange(temp);
  };

  useEffect(() => {

    if (userType === 'admin') {

      isChart && fetchAllRecords();
    } else {
      // getBrandChart()
    }
  }, [isChart, range]);

  const getProjectSummary = async (props) => {
    try {
      const resp = await projectReport('projectsummary');
      if (resp?.status === 200) {
        setProjectSummary(resp?.data);
      }
    } catch (error) {
      console.log(error.message);
      return;
    }
  };
  const getProjectReportByName = async (props) => {
    try {
      const resp = await projectReport('receiver');
      if (resp?.status === 200) {
        setPrjectReportByName(resp?.data);
      }
    } catch (error) {
      console.log(error.message);
      return;
    }
  };
  const getProjectOverallReport = async (props) => {
    try {
      const resp = await projectReport('overall');
      if (resp?.status === 200) {
        setPrjectOverallReport(resp?.data);
      }
    } catch (error) {
      console.log(error.message);
      return;
    }
  };
  const getProjectReportByPayer = async (props) => {
    try {
      const resp = await projectReport('paidBy');
      if (resp?.status === 200) {
        setPrjectReportByPayer(resp?.data);
      }
    } catch (error) {
      console.log(error.message);
      return;
    }
  };
  const getProjectReportByLocation = async (props) => {
    try {
      const resp = await projectReport('location');
      if (resp?.status === 200) {
        setPrjectReportByLocation(resp?.data);
      }
    } catch (error) {
      console.log(error.message);
      return;
    }
  };
  const getTeamPaymentReport = async (props) => {
    try {
      const resp = await projectReport('overallpaidReport');
      if (resp?.status === 200) {
        setteamPaymentReport(resp?.data);
      }
    } catch (error) {
      console.log(error.message);
      return;
    }
  };
  const getBrandDashboardCount = async () => {
    try {
      const resp = await brandDashboardCount(user?.userDetail?.brand_id);
      if (resp?.status === 200 && resp?.data?.statusCode === 200) {
        setCount({
          offers: resp?.data?.data?.getAllOffers || 0,

        });
      }
    } catch (error) {
      console.log(error.message);
      return;
    }
  };

  const fetchAllRecords = async (props) => {
    try {

      const payload = {
        "startDate": range['startDate'],
        "endDate": range['endDate'],
        "isAll": false
      }
      const chartType = isChart === 'campaign' ? 'offers' : isChart
      const resp = await DashboardChartDetails(chartType, payload);
      if (resp?.data?.statusCode === 200) {
        setIsOpen(false)
        if (resp.data.data.getAllRecords) {
          setOptions(resp.data.data.getAllRecords["agg_dates"]);
          setChartSeries(resp.data.data.getAllRecords["agg_count"]);
        }
      }
    } catch (error) {
      console.log(error.message);
      return;
    }
  };


  const getBrandChart = async () => {
    try {
      const payload = {
        "startDate": range['startDate'],
        "endDate": range['endDate'],
        "isAll": false
      }
      const resp = await brandChart(user?.userDetail?.brand_id, payload);
      if (resp?.data?.statusCode === 200) {

        if (resp.data.data.getAllRecords) {
          setOptions(resp.data.data.getAllRecords["agg_dates"]);
          setChartSeries(resp.data.data.getAllRecords["agg_count"]);
        }
      }
    } catch (error) {
      console.log(error.message);
      return;
    }
  };

  function handleNavigation(reportId, id) {
    navigate(`/admin/report-details/${reportId}/${id}`);
  }


  useEffect(() => {
    if (userType === 'admin') {

      getProjectSummary();
      getTeamPaymentReport();
      getProjectReportByName();
      getProjectReportByPayer();
      getProjectReportByLocation();
      getProjectOverallReport();
    } else {
      // getBrandDashboardCount()
    }
  }, []);

  var chartData=[];
  var chartCatagories=[];
  return (
    <div>
      <div className="row mb_34">
        <h2>Overall</h2>
        {ProjectOverallReport.map((reportOverall) => (
          <div className="col-lg-3 mob_mb24 ">
             
              <div
              className="dashboard_item  cursorPointer"
            >
             <p className="SteelWoolClr_text fontSize16 fontWeight500">
                Name : {reportOverall.label}
              </p>
              <hr />
              <div className={styles.carditemstyle}>
              
              <BarChart data={chartData} categories={chartCatagories} />
              <div className={styles.cardparagraphitemstyle}>
              
              
            {reportOverall.fields.map((fields) => (
              

                <p
                  className={'SteelWoolClr_text fontSize16 fontWeight500'}
                  style={{ textAlign: 'left' }}
                >
                  {fields.label}    :
                  {formatNumber(fields.value)}
                </p>
              
              
            ))}
            </div>
          </div>
          </div>
          </div>
        ))}

      </div>
      <div className="row mb_34">
        <h4>Project summary</h4>
        {ProjectSummary.map((count) => (
          <div className="col-lg-3 mob_mb24">


            <div
              className="dashboard_item  cursorPointer"
            >
              <p className="SteelWoolClr_text fontSize16 fontWeight500">
                Name : {count.name} ( {formatNumber(count.value)})
                {
                  (count.expenseCurrentValue > count.expenseValue) &&
                  <span className="badge rounded-pill bg-danger">{formatNumber(count.expenseCurrentValue)} / {count.expenseValue} %</span>
                }
                {
                  (count.expenseCurrentValue <= count.expenseValue) &&
                  <span className="badge rounded-pill bg-success">{formatNumber(count.expenseCurrentValue)} / {count.expenseValue} %</span>
                }
              </p>
              <hr />

              <div className={styles.carditemstyle}>
                <RadialBarChart data={[formatNumber((count.expenseCurrentValue))]} />
                <div className={styles.cardparagraphitemstyle}>

                  <p
                    className={'SteelWoolClr_text fontSize16 fontWeight500'}
                    style={{ textAlign: 'left' }}
                  >
                    Credit    :
                    {formatNumber(count.credit)}
                  </p>
                  <p
                    className={'SteelWoolClr_text fontSize16 fontWeight500'}
                    style={{ textAlign: 'left' }}
                  >
                    Debit     :
                   {formatNumber(count.debit)}
                   <p>{count.debit}</p> 
                  </p>

                  {<b
                    className={'fontSize15 fontWeight600 blackClr_text '}
                    style={{ textAlign: 'left' }}
                  >
                    Remaining :
                    {formatNumber(count.remaining)}
                  </b>
                  }
                     {count.description &&  <p
                      className={'fontSize15 fontWeight600 blackClr_text' }
                      style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word', textAlign: 'left' }}
                    >
                    Details :
                    <span style={{ display: 'inline-block', maxWidth: '100%' }}>{String(count.description)}</span>
                  </p>
                  }

                </div>
              </div>
              <div className="displayFlex alignItem_center gap12">
                <div>
                  <img src={GrapharrowIcon} alt="OpenlinkIcon" />
                </div>
              </div>
            </div>

          </div>
        ))}

      </div>
      <div className="row mb_34">
        <h4>Team payment handling </h4>
        {teamPaymentReport.map((count) => (
          <div className="col-lg-3 mob_mb24">


            <div
              className="dashboard_item  cursorPointer"
              onClick={() => handleNavigation("paidBy", count.id)}
            >
              <p className="SteelWoolClr_text fontSize16 fontWeight500">
                Name : {count.name}
              </p>
              <hr />
              <div className={styles.carditemstyle}>
                {<p className="SteelWoolClr_text fontSize16 fontWeight500" style={{ textAlign: 'left' }}>
                  Credit    :
                  {formatNumber(count.credit)}
                </p>}
                <p className="SteelWoolClr_text fontSize16 fontWeight500" style={{ textAlign: 'left' }}>
                  Debit     :
                 {formatNumber(count.debit)}
                </p>

                {<b className={'fontSize15 fontWeight600 blackClr_text ' + (count.remaining < 0 ? ' blink' : '')} style={{ textAlign: 'left' }}>
                  Remaining :
                  {formatNumber(count.remaining)}
                </b>
                }
                  {count.description &&  <p
                    className={'fontSize15 fontWeight600 blackClr_text ' }
                    style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word', textAlign: 'left' }}
                  >
                Details :
                <span style={{ display: 'inline-block', maxWidth: '100%' }}>{String(count.description)}</span>
              </p>
              }
              </div>

              <div className="displayFlex alignItem_center gap12">
                <div>
                  <img src={GrapharrowIcon} alt="OpenlinkIcon" />
                </div>
              </div>
            </div>

          </div>
        ))}

      </div>

      <div className="row mb_34">
        <h4>Report by receiver-MY</h4>
        {ProjectReportByName.map((count) => (
          <div className="col-lg-3 mob_mb24">


            <div
              className="dashboard_item  cursorPointer"
              onClick={() => handleNavigation("receiver", count.receiverId)}
            >
              <p className="SteelWoolClr_text fontSize16 fontWeight500">
                Name : {count.receiver}
              </p>
              <hr />
              {<p className="SteelWoolClr_text fontSize16 fontWeight500" style={{ textAlign: 'left' }}>
                Credit    :
                {formatNumber(count.credit)}
              </p>}
              <p className="SteelWoolClr_text fontSize16 fontWeight500" style={{ textAlign: 'left' }}>
                Debit     :
               {formatNumber(count.debit)}
              </p>

              {<b className={'fontSize15 fontWeight600 blackClr_text '} style={{ textAlign: 'left' }}>
                Remaining :
                {formatNumber(count.remaining)}
              </b>
              
              }
                {count.description &&<p
                    className={'fontSize15 fontWeight600 blackClr_text'}
                    style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word', textAlign: 'left' }}
                  >
                    Details :
                    <span style={{ display: 'inline-block', maxWidth: '100%' }}>{String(count.description)}</span>
                  </p>
                  }


              <div className="displayFlex alignItem_center gap12">
                <div>
                  <img src={GrapharrowIcon} alt="OpenlinkIcon" />
                </div>
              </div>
            </div>

          </div>
        ))}

      </div>

      <div className="row mb_34">
        <h4>Transaction carried by Project </h4>
        {ProjectReportByPayer.map((count) => (
          <div className="col-lg-3 mob_mb24">


            <div
              className="dashboard_item  cursorPointer  "
              onClick={() => handleNavigation("projectsummary", count.id)}
            >
              <p className="SteelWoolClr_text fontSize16 fontWeight500">
                Projet Name : {count.name}
              </p>
              <p className="SteelWoolClr_text fontSize16 fontWeight500">
                Name : {count.paidBy}
              </p>
              <hr />
              {<p className="SteelWoolClr_text fontSize16 fontWeight500" style={{ textAlign: 'left' }}>
                Credit    :
                {formatNumber(count.credit)}
              </p>}
              <p className="SteelWoolClr_text fontSize16 fontWeight500" style={{ textAlign: 'left' }}>
                Debit     :
               {formatNumber(count.debit)}
              </p>

              {<b className={'fontSize15 fontWeight600 blackClr_text ' } style={{ textAlign: 'left' }}>

                Remaining :
                {formatNumber(count.remaining)}
              </b>
              }
            {count.description &&  <p
                  className={'fontSize15 fontWeight600 blackClr_text' }
                  style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word', textAlign: 'left' }}
                >

                Details :
                <span style={{ display: 'inline-block', maxWidth: '100%' }}>{String(count.description)}</span>
              </p>
              }
              <div className="displayFlex alignItem_center gap12">
                <div>
                  <img src={GrapharrowIcon} alt="OpenlinkIcon" />
                </div>
              </div>
            </div>

          </div>
        ))}

      </div>
      <div className="row mb_34">
        <h4>REPORT BY LOCATION</h4>
        {ProjectReportByLocation.map((count) => (
          <div className="col-lg-3 mob_mb24">


            <div
              className="dashboard_item  cursorPointer"
              onClick={() => handleNavigation("location", count.locationId)}
            >
              <p className="SteelWoolClr_text fontSize16 fontWeight500">
                Name : {count.name}
              </p>
              <p className="SteelWoolClr_text fontSize16 fontWeight500">
                Name : {count.locationName}
              </p>
              <hr />
              {<p className="SteelWoolClr_text fontSize16 fontWeight500" style={{ textAlign: 'left' }}>
                Credit    :
                {formatNumber(count.credit)}
              </p>}
              <p className="SteelWoolClr_text fontSize16 fontWeight500" style={{ textAlign: 'left' }}>
                Debit     :
               {formatNumber(count.debit)}
              </p>

              {<b className={'fontSize15 fontWeight600 blackClr_text ' } style={{ textAlign: 'left' }}>
                Remaining :
                {formatNumber(count.remaining)}
              </b>
              }
               {count.description &&  <p
                    className={'fontSize15 fontWeight600 blackClr_text' }
                    style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word', textAlign: 'left' }}
                  >

                Details :
                <span style={{ display: 'inline-block', maxWidth: '100%' }}>{String(count.description)}</span>
              </p>
              }


              <div className="displayFlex alignItem_center gap12">
                <div>
                  <img src={GrapharrowIcon} alt="OpenlinkIcon" />
                </div>
              </div>
            </div>

          </div>
        ))}

      </div>
    </div>
  );
};

export default Dashboard;
